/**
 * WebSmWayback — the "prove you mean it" return gate (ported from Glow's
 * WebSmWayback_type.jsx). Options: Title / Message / Submessage / RequirePhrase
 *   / Placeholder / ButtonLabel / BgColor / AccentColor / ButtonBgColor
 *   / ButtonTextColor. Emits CLICK1 once the member passes.
 */
import { useState } from "react";
import {
  ACTION_BTN_CLASS,
  CARD_CLASS,
  MESSAGE_CLASS,
  PRIMARY_BTN_CLASS,
  SECTION_CLASS,
  SUBMESSAGE_CLASS,
  TITLE_CLASS,
  stepVars,
} from "./step-shell";
import type { StepTypeProps } from "./types";

const norm = (s: string) =>
  String(s || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

export default function WebSmWaybackType({ getOpt, dispatch }: StepTypeProps) {
  const bg = getOpt("BgColor") || "#0a0809";
  const accent = getOpt("AccentColor") || "#d6a94e";
  const btnText = getOpt("ButtonTextColor") || "#f2dba6";

  const title = getOpt("Title") || "You said no. Prove us wrong.";
  const message =
    getOpt("Message") || "Type the words, and we'll know you mean them:";
  const submessage = getOpt("Submessage");
  const require = getOpt("RequirePhrase") || "";
  const placeholder = getOpt("Placeholder") || "type it here";
  const buttonLabel = getOpt("ButtonLabel") || "I mean it";

  const [val, setVal] = useState("");
  const gated = Boolean(require);
  const ok = gated ? norm(val) === norm(require) : true;

  const pass = () => {
    if (ok) dispatch("CLICK1");
  };

  return (
    <section
      style={stepVars({ accent, bg, btnText })}
      className={`${SECTION_CLASS} px-4 py-12`}
    >
      <div className={CARD_CLASS}>
        {title ? <div className={TITLE_CLASS}>{title}</div> : null}
        {message ? <div className={MESSAGE_CLASS}>{message}</div> : null}
        {submessage ? (
          <div className={SUBMESSAGE_CLASS}>{submessage}</div>
        ) : null}

        {gated ? (
          <>
            <div className="mt-5 flex gap-2.5">
              <input
                type="text"
                value={val}
                placeholder={placeholder}
                onChange={(e) => setVal(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") pass();
                }}
                className="min-w-[160px] flex-1 rounded-[7px] border border-[var(--sm-accent-soft)] bg-[rgb(8_7_8/0.7)] px-[15px] py-[13px] text-[17px] text-[#ece4d2] outline-none"
              />
              <button
                type="button"
                onClick={pass}
                disabled={!ok}
                className={`${ACTION_BTN_CLASS} rounded-[7px] px-4 font-stencil text-xs tracking-[1px]`}
              >
                {buttonLabel}
              </button>
            </div>
            <div
              className={`mt-3 text-center text-[12.5px] ${ok ? "text-[#6fbf95]" : "text-[#9b8f79]"}`}
            >
              {ok ? "✓ we believe you" : `type exactly: "${require}"`}
            </div>
          </>
        ) : (
          <button
            type="button"
            onClick={pass}
            className={`mt-[22px] ${PRIMARY_BTN_CLASS}`}
          >
            {buttonLabel}
          </button>
        )}
      </div>
    </section>
  );
}
